module.exports = __webpack_public_path__ + "static/media/image 38.0c1243d5.png";